import { isEmpty, isNil } from 'lodash'
import { QUESTION_TYPE } from 'types'
import * as Yup from 'yup'

// Translates the constraints the API sends with each custom question into Yup validators,
// keyed by form field name. Questions whose photo upload was already attempted are listed
// in formKeysSkipValidation and are left unvalidated so a failed upload can't trap the user.
export default function questionValidationSchema(
  questions,
  formKeysSkipValidation = []
) {
  return questions.reduce(
    (
      constraints,
      { fieldName, type, title, required, constraints: questionConstraints }
    ) => {
      if (isNil(questionConstraints) || isEmpty(questionConstraints)) {
        return constraints
      }
      let questionSchema
      let lengthObjectType
      if (type === QUESTION_TYPE.PHOTO) {
        questionSchema = Yup.array()
        lengthObjectType = 'photos'
      } else {
        questionSchema = Yup.string()
        lengthObjectType = 'characters'
      }

      const { presence, length } = questionConstraints
      const { minimum, maximum, message: lengthMessage } = length ?? {}

      // "Must provide enough" rules (presence + minimum) only apply to required
      // questions, and are waived once a photo upload has been attempted so a
      // failed upload can't trap the user on that field.
      const enforceRequiredness =
        required && !formKeysSkipValidation.includes(fieldName)
      if (enforceRequiredness) {
        if (presence) {
          let presenceMessage = `${title} can't be blank`
          if (typeof presence === 'object' && presence.message) {
            presenceMessage = presence.message
          }
          questionSchema = questionSchema.required(presenceMessage)
        }

        if (minimum != undefined) {
          const minMessage =
            lengthMessage ||
            `Minimum of ${minimum} ${lengthObjectType} required`
          questionSchema = questionSchema.min(minimum, minMessage)
        }
      }

      // "Must not exceed" rule: a maximum is a hard cap regardless of required-ness,
      // so it always applies.
      if (maximum != undefined) {
        const maxMessage =
          lengthMessage || `Maximum of ${maximum} ${lengthObjectType} allowed`
        questionSchema = questionSchema.max(maximum, maxMessage)
      }

      constraints[fieldName] = questionSchema
      return constraints
    },
    {}
  )
}
